import React from 'react';
import ReportFrame from '../ReportFrame';

export default class IobSummary extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper'>
        <ReportFrame
          reportName='IOB Summary'
          reportParams={reportParams}
          id='iobsummary'
          name='iobsummary'
          title='IOB Summary'
        />
      </div>
    );
  }
}
